/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_HoursInputs */

const es_footer_hours = /** @type {(inputs: Footer_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De lunes a domingo · A la hora que te venga mejor a ti`)
};

const gl_footer_hours = /** @type {(inputs: Footer_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De luns a domingo · Á hora que che conveña`)
};

const en_footer_hours = /** @type {(inputs: Footer_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday to Sunday · Whenever suits you best`)
};

/**
* | output |
* | --- |
* | "Monday to Sunday · Whenever suits you best" |
*
* @param {Footer_HoursInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_hours = /** @type {((inputs?: Footer_HoursInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_HoursInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_hours(inputs)
	if (locale === "en") return en_footer_hours(inputs)
	return es_footer_hours(inputs)
});